// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fade-enter-active,.fade-leave-active{transition:opacity var(--fade-speed)}.fade-enter,.fade-leave-to{opacity:0}.slide-left-enter-active,.slide-left-leave-active{transition:1s}.slide-left-enter,.slide-left-leave-to{transform:translateX(-100%)}.slide-right-enter-active,.slide-right-leave-active{transition:1s}.slide-right-enter,.slide-right-leave-to{transform:translateX(100%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
